module.exports = __webpack_public_path__ + "static/Header-d76c1df4ca4bd1145d4d45e3683ddee5.png";